export const inspectionPortalQueryKeys = {
  all: (token: string | undefined) => ['inspection-portal', token] as const,
  session: (token: string | undefined) =>
    [...inspectionPortalQueryKeys.all(token), 'session', token] as const,
  qrIcon: (uuid: string | null, token: string | undefined) =>
    [...inspectionPortalQueryKeys.all(token), 'qr-icon', uuid] as const,
  registry: (
    module: string,
    from?: string | null,
    to?: string | null,
    token?: string | undefined,
  ) =>
    [
      ...inspectionPortalQueryKeys.all(token),
      'registry',
      module,
      from ?? null,
      to ?? null,
    ] as const,
  inactivityPeriods: (module: string, token?: string | undefined) =>
    [...inspectionPortalQueryKeys.all(token), 'inactivity-periods', module] as const,
  documents: (token?: string | undefined) =>
    [...inspectionPortalQueryKeys.all(token), 'documents'] as const,
  transportDocuments: (from?: string | null, to?: string | null, token?: string | undefined) =>
    [
      ...inspectionPortalQueryKeys.all(token),
      'transport-documents',
      from ?? null,
      to ?? null,
    ] as const,
  lot: (qrUuid: string, token?: string | undefined) =>
    [...inspectionPortalQueryKeys.all(token), 'lot', qrUuid] as const,
  recallCases: (token?: string | undefined) =>
    [...inspectionPortalQueryKeys.all(token), 'recall-cases'] as const,
};
